import React, { useEffect, useState, useRef } from 'react';

interface ParallaxImageProps {
  src: string;
  alt?: string;
  className?: string;
  overlayClass?: string;
  height?: string;
}

const ParallaxImage: React.FC<ParallaxImageProps> = ({
  src,
  alt = "",
  className = "",
  overlayClass = "bg-white/5",
  height = "h-[160px] md:h-[600px]",
}) => {
  const [isMobile, setIsMobile] = useState(false);
  const parallaxRef = useRef<HTMLDivElement>(null);
  
  useEffect(() => {
    // Check if mobile on component mount
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    // Initial check
    checkMobile();
    
    // Listen for resize events
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);
  
  // We'll use CSS fixed background for the parallax effect
  
  return (
    <div className={`relative overflow-hidden ${height} ${className}`}>  
      <div className="glass-card absolute inset-0 rounded-xl overflow-hidden shadow-xl">
        <div
          ref={parallaxRef}
          className="absolute inset-0 bg-center bg-no-repeat"
          style={{
            backgroundImage: `url(${src})`,
            // Use a larger background size on mobile to prevent edges from showing
            backgroundSize: isMobile ? '200% auto' : 'cover',
            backgroundPosition: 'center center',
            // Use fixed attachment for both mobile and desktop for parallax effect
            backgroundAttachment: 'fixed',
          }}
        />
        
        {/* Overlay */}
        <div className={`absolute inset-0 backdrop-blur-[1px] ${overlayClass}`}></div>
      </div>
    </div>
  );
};

export default ParallaxImage;